import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectorSimpleFactory } from "../logic";
function viajeSearchString(x: models.ViajeZEDto) {
    return `${x.Folio} ${x.NombreSucursal} ${x.NombreVehiculoZE} ${models.StatusViajeEAD[x.Status]}  ${x.NombreChoferZE} `;
}

class ViajeZEItem extends React.PureComponent<{ value: models.ViajeZEDto }> {
    render() {
        const x = this.props.value;
        return (
            <div>
                <span>
                    <b>Folio:</b>{" "}{x.Folio}{", "}
                    <b>Status:</b>{" "}{models.StatusViajeZE[x.Status]}
                </span>
                <br />
                <span>
                    <b>Sucursal:</b>{" "}{x.NombreSucursal}{", "}
                    <b>Vehículo:</b>{" "}{x.NombreVehiculoZE}{", "}
                </span>
                <br />
                <span>
                    <b>Chofer:</b>{" "}{x.NombreChoferZE}{", "}
                    <b>Sucursal:</b>{" "}{x.NombreSucursal}
                </span>
            </div>
        )
    }
}

export const ViajeZE =
    SelectorSimpleFactory(
        observeResource(resources.ViajeZE.ConsultarViajes, {}),
        x => x.IdRegistro,
        x => ({
            label: viajeSearchString(x),
            view: <ViajeZEItem value={x} />
        })
    );


// WEBPACK FOOTER //
// ./app/features/selectores/items/viajeze.tsx